import { useState } from "react";
import BulkSipStatusModal from "./BulkSipStatusModal";

export default function BulkSipStatusActions({
  items,
  onApplied,
  excludedComplexCount = 0,
  sourceSection = "admin",
  buttonStyle,
  buttonClassName,
  dangerButtonClassName,
}) {
  const [nextStatus, setNextStatus] = useState(null);

  return (
    <>
      <button type="button" className={buttonClassName} style={buttonStyle} onClick={() => setNextStatus(true)}>
        Включить клиентов
      </button>
      <button type="button" className={dangerButtonClassName || buttonClassName} style={buttonStyle ? { ...buttonStyle, background: "var(--danger-soft)", color: "var(--danger)", borderColor: "var(--danger)" } : undefined} onClick={() => setNextStatus(false)}>
        Остановить клиентов
      </button>
      <BulkSipStatusModal
        isOpen={typeof nextStatus === "boolean"}
        items={items}
        status={nextStatus}
        sourceSection={sourceSection}
        excludedComplexCount={excludedComplexCount}
        onClose={() => setNextStatus(null)}
        onApplied={onApplied}
      />
    </>
  );
}
